export const COLUMNAS = [
  { id: 'por_hacer', titulo: 'Por Hacer', color: 'bg-gray-100' },
  { id: 'asignado', titulo: 'Asignado', color: 'bg-blue-100' },
  { id: 'en_proceso', titulo: 'En Proceso', color: 'bg-yellow-100' },
  { id: 'en_revision', titulo: 'En Revisión', color: 'bg-purple-100' },
  { id: 'finalizado', titulo: 'Finalizado', color: 'bg-green-100' },
];

export const PRIORIDADES = {
  alta: { label: 'Alta', color: 'bg-red-100 text-red-800', icon: '🔴' },
  media: { label: 'Media', color: 'bg-yellow-100 text-yellow-800', icon: '🟡' },
  baja: { label: 'Baja', color: 'bg-green-100 text-green-800', icon: '🟢' },
};

export const VISTAS = [
  { id: 'kanban', label: 'Tablero', icon: 'CheckSquare' },
  { id: 'lista', label: 'Lista', icon: 'List' },
  { id: 'calendario', label: 'Calendario', icon: 'Calendar' },
  { id: 'responsable', label: 'Por Responsable', icon: 'User' },
  { id: 'lote', label: 'Por Lote', icon: 'MapPin' },
];

export const getTareaFormInitial = () => ({
  titulo: '',
  descripcion: '',
  prioridad: 'media',
  labor_id: '',
  labor_nombre: '',
  lote_id: '',
  lote_nombre: '',
  centros: [],
  responsable_id: '',
  responsable_nombre: '',
  fecha_planificada: '',
  notas_adicionales: '',
  subtareas: [],
  materiales_requeridos: [],
});

export const tareaToFormData = (tarea) => ({
  titulo: tarea.titulo,
  descripcion: tarea.descripcion || '',
  prioridad: tarea.prioridad,
  labor_id: tarea.labor_id || '',
  labor_nombre: tarea.labor_nombre || '',
  lote_id: tarea.lote_id || '',
  lote_nombre: tarea.lote_nombre || '',
  centros: tarea.centros || [],
  responsable_id: tarea.responsable_id || '',
  responsable_nombre: tarea.responsable_nombre || '',
  fecha_planificada: tarea.fecha_planificada || '',
  notas_adicionales: tarea.notas_adicionales || '',
  subtareas: tarea.subtareas || [],
  materiales_requeridos: tarea.materiales_requeridos || [],
});

export const esFechaVencida = (fechaPlanificada, estado) => {
  return fechaPlanificada && 
    new Date(fechaPlanificada) < new Date() && 
    estado !== 'finalizado';
};

export const calcularProgresoSubtareas = (subtareas) => {
  if (!subtareas || subtareas.length === 0) return 0;
  const completadas = subtareas.filter(st => st.completada).length;
  return Math.round((completadas / subtareas.length) * 100);
};

export const calcularTiempoTranscurrido = (fechaCreacion) => {
  if (!fechaCreacion) return 'N/A';

  const fechaInicio = new Date(fechaCreacion);
  const ahora = new Date();
  const diferenciaMilisegundos = ahora - fechaInicio;

  // Convertir a diferentes unidades
  const segundos = Math.floor(diferenciaMilisegundos / 1000);
  const minutos = Math.floor(segundos / 60);
  const horas = Math.floor(minutos / 60);
  const dias = Math.floor(horas / 24);
  const semanas = Math.floor(dias / 7);
  const meses = Math.floor(dias / 30);

  // Retornar formato más legible
  if (meses > 0) return `${meses} ${meses === 1 ? 'mes' : 'meses'}`;
  if (semanas > 0) return `${semanas} ${semanas === 1 ? 'semana' : 'semanas'}`;
  if (dias > 0) return `${dias} ${dias === 1 ? 'día' : 'días'}`;
  if (horas > 0) return `${horas} ${horas === 1 ? 'hora' : 'horas'}`;
  if (minutos > 0) return `${minutos} ${minutos === 1 ? 'minuto' : 'minutos'}`;
  return 'Recién creada';
};

export const obtenerColorTiempo = (fechaCreacion) => {
  if (!fechaCreacion) return 'text-gray-600';

  const fechaInicio = new Date(fechaCreacion);
  const ahora = new Date();
  const dias = Math.floor((ahora - fechaInicio) / (1000 * 60 * 60 * 24));

  if (dias >= 7) return 'text-red-600 font-semibold'; // Más de 1 semana
  if (dias >= 3) return 'text-orange-600 font-semibold'; // Más de 3 días
  if (dias >= 1) return 'text-yellow-600 font-semibold'; // Más de 1 día
  return 'text-green-600'; // Menos de 1 día
};
